// components/Services.js
import React from 'react';
import styled from 'styled-components';
import { FaBook, FaUsers, FaHandshake, FaBullhorn } from 'react-icons/fa';

const ServicesSection = styled.section`
  padding: 4rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

const ServiceCard = styled.div`
  text-align: center;
  padding: 2rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-5px);
  }
`;

const IconWrapper = styled.div`
  font-size: 2.5rem;
  color: ${props => props.theme.colors.secondary};
  margin-bottom: 1rem;
`;

const Services = () => {
  const services = [
    {
      icon: <FaBook />,
      title: 'Educational Resources',
      description: 'Access to educational materials and resources for parents.',
    },
    {
      icon: <FaUsers />,
      title: 'Support Groups',
      description: 'Connect with other parents and share experiences.',
    },
    {
      icon: <FaHandshake />,
      title: 'Advocacy',
      description: 'Representation in educational policy matters.',
    },
    {
      icon: <FaBullhorn />,
      title: 'Workshops',
      description: 'Regular workshops and training sessions for parents.',
    },
  ];

  return (
    <ServicesSection>
      <h2>Our Services</h2>
      <ServiceGrid>
        {services.map((service, index) => (
          <ServiceCard key={index}>
            <IconWrapper>{service.icon}</IconWrapper>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </ServiceCard>
        ))}
      </ServiceGrid>
    </ServicesSection>
  );
};

export default Services;